import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { AirbnbOfficialBookingValidation } from 'uplisting-frontend/validations';

export default class AirbnbOfficialBookingRepositoryService extends BaseRepositoryService<
  ModelRegistry['airbnb-official-booking']
> {
  recordName = 'airbnb-official-booking';
  implementMethods = ['buildChangeset'];

  validation = AirbnbOfficialBookingValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/airbnb-official-booking': AirbnbOfficialBookingRepositoryService;
  }
}
